import * as React from 'react';
import { createSelectable, TSelectableItemProps } from '../../../../components/drag-select';
import { formatCurrency } from '../../../../utils/currency-formatter';
import { toSimpleDateTime, toSlashedShortDate } from '../../../../utils/date-utils';
import { CreditHoldOrderDetails } from '../../../../modules/ordering/models/credit-hold-details';

interface IProps extends TSelectableItemProps {
    orderItem: CreditHoldOrderDetails;
}

export const CreditHoldDetailsRow = (props : IProps) => {

    const { selectableRef, 
        isSelected, 
        isSelecting, 
        orderItem
     } = props;

     let actualClass = 'order-selectable';
     actualClass += (orderItem.isChecked) ? ' highlight' : '';
     actualClass += (isSelecting) ? ' dragging' : '';
     actualClass += (isSelected) ? ' selected-already' : '';
        
    return orderItem 
            ? <tr key={orderItem.id} 
                ref={selectableRef}  
                className={ actualClass }>
                <td>
                    <input
                        type="checkbox"
                        checked={orderItem.isChecked}
                        onChange={() => { return; }}
                    />
                </td>
                <td>{ orderItem.id }</td>
                <td>{ orderItem.description }</td>
				<td>{ orderItem.poNumber }</td>
				<td>{ orderItem.jobName }</td>
                <td>{ orderItem.cutoffDate ? toSlashedShortDate(orderItem.cutoffDate) : '' }</td>
                <td>{ orderItem.createdOn ? toSimpleDateTime(orderItem.createdOn) : '' }</td>
                <td>{ formatCurrency(orderItem.total) }</td>
            </tr>
        : <tr/>;

};

export default createSelectable(CreditHoldDetailsRow);
